module.exports = __webpack_public_path__ + "static/img/3.e1d43be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/zh/3.png
// module id = JVjC
// module chunks = 0